export const headers = [
  {
    headerName: 'Código Vehículo',
    field: 'cod_vehiculo',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Patente',
    field: 'patente_vehiculo',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Flota',
    field: '__nom_flota',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Fecha Última Transmisión',
    field: 'fecha_actividad',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Días Sin Transmitir',
    field: 'dias_sin_transmitir',
    sortable: true,
    resizable: true,
    minWidth: 80,
    lockPinned: true,
  },
  {
    headerName: 'Ubicación',
    field: 'ubicacion',
    sortable: true,
    resizable: true,
    minWidth: 160,
    lockPinned: true,
  },
  {
    headerName: 'Dirección',
    field: 'ubicacion',
    sortable: true,
    resizable: true,
    minWidth: 160,
    lockPinned: true,
  },
];
